import { DatePicker } from './../components/date_picker_controller';
import { DatePickerBaseServant } from './date_picker_base_servant';
import { IDay, IWeekDay } from './../date_picker_interface';
import * as _4 from 'lodash4';

export class DatePickerSchedulingServant extends DatePickerBaseServant {
  private servant: DatePickerBaseServant;
  private _onSelect: Function;

  constructor(ngDatePickerBaseServant: DatePickerBaseServant) {
    super();
  }

  public constructDates(dates: Array<string>): Array<IDay> {
    let tempObj: Array<IDay> = [];
    _4.forEach(dates, (date) => {
      tempObj.push(this.buildTimeObject(moment(date, 'YYYY-MM-DDThh:mm:ss:A')));
    });
    return tempObj;
  }

  public initialize(datePicker: DatePicker): void {
    let updatedSelectTime: IDay = {} as IDay;
    if (!_4.isEmpty(datePicker.selectedTime)) {
      const selectedDateMoment: moment.Moment = datePicker.selectedTime.date.add(0, 'days');
      datePicker.selectedDay = this.buildWeekDayObject(selectedDateMoment, selectedDateMoment.day(), true);
      updatedSelectTime = _4.find(datePicker.timingArray, { date: datePicker.selectedTime.date });
    }

    if (!_4.isEmpty(updatedSelectTime)) {
      updatedSelectTime.selected = true;
      datePicker.selectedTime = updatedSelectTime;
    }

    this._onSelect = datePicker.onSelect;
  }

  public selectionChange(selectedDay: IWeekDay, selectedTime: IDay): any {
    this._onSelect({ item: selectedTime });
  }

  public nextWeek(datePicker: DatePicker, preserveSelections?: boolean): void {
    datePicker.onNextweekSelection().then((times: Array<string>) => {
      datePicker.resetOnSelectionChange();
      datePicker.timingArray = this.constructDates(times);

      let start_of_week =
        _4.size(datePicker.timingArray) === 0
          ? datePicker.current_week_lastdate
          : moment(_4.first(datePicker.timingArray).date).startOf('week');
      datePicker.week = this.getWeek(start_of_week, datePicker);
      datePicker.isPreviousWeekEnabled();
    });
  }

  public previousWeek(datePicker: DatePicker): void {
    datePicker.onPreviousweekSelection().then((times: Array<string>) => {
      datePicker.resetOnSelectionChange();
      datePicker.timingArray = this.constructDates(times);
      let start_of_week =
        _4.size(datePicker.timingArray) === 0
          ? datePicker.previous_week_firstdate
          : moment(_4.first(datePicker.timingArray).date).startOf('week');
      datePicker.week = this.getWeek(start_of_week, datePicker);
      datePicker.isPreviousWeekEnabled();
    });
  }

  public hasSelectedTime(time: IDay, selectedTime: IDay): boolean {
    return !!time && !!selectedTime && moment(time.date).isSame(moment(selectedTime.date));
  }

  public getAvailableTimes(timingArray: Array<IDay>, selectedDay: IWeekDay): Array<IDay> {
    return _4.filter(timingArray, { day_week: selectedDay.day_week });
  }

  public getWeekStartDate(timingArray: Array<IDay>): moment.Moment {
    return _4.size(timingArray) > 0 ? moment(_4.first(timingArray).date).startOf('week') : moment().startOf('week');
  }
}

angular.module('ui-ng-mobile-date-picker').service('ngDatePickerSchedulingServant', DatePickerSchedulingServant);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-mobile-date-picker/src/servants/date_picker_scheduling_servant.ts